<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'ENVIRONMENT-TEST'" [breadcrumb]="''" [count]="''"
    icon="fa-traffic-cone">
</app-breadcrumb>
<kendo-tabstrip style="background-color: #fff;" (tabSelect)="onTabSelect($event)">
    <kendo-tabstrip-tab title="Buttons & Modals" [selected]="selectedTab === 0">
        <ng-template kendoTabContent>
            <div class="k-form">
                <app-test-buttons></app-test-buttons>
            </div>
        </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Dates & Times" [selected]="selectedTab === 1">
        <ng-template kendoTabContent>
            <div class="k-form">
                <app-test-dates></app-test-dates>
            </div>
        </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Dropdowns" [selected]="selectedTab === 2">
        <ng-template kendoTabContent>
            <div class="k-form">
                <app-test-dropdowns></app-test-dropdowns>
            </div>
        </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Grids" [selected]="selectedTab === 3">
        <ng-template kendoTabContent>
            <div class="k-form">
                <app-test-grids></app-test-grids>
            </div>
        </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Inputs" [selected]="selectedTab === 4">
        <ng-template kendoTabContent>
            <div class="k-form">
                <app-test-inputs></app-test-inputs>
            </div>
        </ng-template>
    </kendo-tabstrip-tab>
</kendo-tabstrip>